(() => {
  const config = document.getElementById('FuntoInterfaceLabels');
  if (!config) return;
  let labels;
  try { labels = JSON.parse(config.textContent); } catch { return; }
  const translate = (value) => {
    if (labels[value]) return labels[value];
    const page = /^Go to slide (\d+)$/.exec(value);
    if (page) return labels.page.replace('[number]', page[1]);
    const slide = /^(\d+) of (\d+)$/.exec(value);
    if (slide) return labels.count.replace('[number]', slide[1]).replace('[total]', slide[2]);
    return value;
  };
  const update = (element) => {
    for (const name of ['aria-label', 'aria-roledescription']) {
      const original = element.getAttribute(name);
      if (!original) continue;
      const translated = translate(original);
      if (translated !== original) element.setAttribute(name, translated);
    }
  };
  const scan = (root) => {
    if (root.nodeType !== 1) return;
    update(root);
    root.querySelectorAll('[aria-label], [aria-roledescription]').forEach(update);
  };
  scan(document.documentElement);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-label', 'aria-roledescription']
  });
})();
